import { Injectable } from '@angular/core';
import { LanguageService } from '../services/language/language.service';

const STRINGS: Record<string, Record<string, string>> = {
  he: {
    'survey.thankYou': 'תודה רבה על שיתוף הפעולה!',
    'survey.close': 'סגירה',
    'survey.answerPlaceholder': 'תשובה',
    'survey.next': 'הבא',
    'survey.submit': 'שלחו משוב',
  },
  en: {
    'survey.thankYou': 'Thank you for your feedback!',
    'survey.close': 'Close',
    'survey.answerPlaceholder': 'Your answer',
    'survey.next': 'Next',
    'survey.submit': 'Submit',
  },
  ar: {
    'survey.thankYou': 'شكرًا لمشاركتك!',
    'survey.close': 'إغلاق',
    'survey.answerPlaceholder': 'إجابتك',
    'survey.next': 'التالي',
    'survey.submit': 'إرسال',
  },
};

@Injectable({ providedIn: 'root' })
export class SurveyI18nService {
  constructor(private readonly languageService: LanguageService) {}

  translate(key: string): string {
    const sym = this.languageService.getSelectedLanguage()?.symbol ?? 'he';
    return STRINGS[sym]?.[key] ?? STRINGS['he'][key] ?? key;
  }
}
